import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=388032fc&scoped=true&"
import script from "./refresh.vue?vue&type=script&lang=js&"
export * from "./refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388032fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388032fc')) {
      api.createRecord('388032fc', component.options)
    } else {
      api.reload('388032fc', component.options)
    }
    module.hot.accept("./refresh.vue?vue&type=template&id=388032fc&scoped=true&", function () {
      api.rerender('388032fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/refresh.vue"
export default component.exports